import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionItemsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionItemDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionItemDocumentSortInput> | Types.ProductionItemDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  includeCombined?: Types.Scalars['Boolean']['input'];
}>;


export type GetProductionItemsQuery = { __typename?: 'Query', productionItems?: { __typename?: 'ProductionItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionItemDocument', absorbedNumbers: Array<string>, id: string, tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, resolvedLaborCostPerUnit?: number | null, resolvedLaborCostSourceType?: string | null, resolvedLaborCostSourceId?: string | null, resolvedLaborCostSourceName?: string | null, status: Types.ProductionItemStatus, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, salesItemId?: string | null, salesItemLinkedAutomatically: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, combinedIntoProductionItemId?: string | null, combinedAt?: Types.TDateISO | null, productionTaskEventAttachments: Array<{ __typename?: 'ProductionItemEventAttachmentDocument', defaultAssignedTo?: string | null, eventId: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ProductionItemSummaryFragment = { __typename?: 'ProductionItemDocument', id: string, tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, resolvedLaborCostPerUnit?: number | null, resolvedLaborCostSourceType?: string | null, resolvedLaborCostSourceId?: string | null, resolvedLaborCostSourceName?: string | null, status: Types.ProductionItemStatus, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, salesItemId?: string | null, salesItemLinkedAutomatically: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, combinedIntoProductionItemId?: string | null, combinedAt?: Types.TDateISO | null, productionTaskEventAttachments: Array<{ __typename?: 'ProductionItemEventAttachmentDocument', defaultAssignedTo?: string | null, eventId: string }> };

export type ProductionItemDataFragment = { __typename?: 'ProductionItemStateData', tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, status: Types.ProductionItemStatus, salesItemId?: string | null };

export type GetProductionItemCombinePreviewQueryVariables = Types.Exact<{
  survivorId: Types.Scalars['String']['input'];
  loserId: Types.Scalars['String']['input'];
}>;


export type GetProductionItemCombinePreviewQuery = { __typename?: 'Query', productionItemCombinePreview: { __typename?: 'ProductionItemCombinePreviewPayload', preview?: { __typename?: 'ProductionItemCombinePreview', survivorId: string, loserId: string, conflictCount: number, fields: Array<{ __typename?: 'ProductionCombineField', key: string, label: string, kind: Types.ProductionCombineFieldKind, survivorValue?: string | null, loserValue?: string | null, resultValue?: string | null, isConflict: boolean, keepBothAllowed: boolean }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ProductionCombineFieldDetailsFragment = { __typename?: 'ProductionCombineField', key: string, label: string, kind: Types.ProductionCombineFieldKind, survivorValue?: string | null, loserValue?: string | null, resultValue?: string | null, isConflict: boolean, keepBothAllowed: boolean };

export type GetProductionItemLinksPreviewQueryVariables = Types.Exact<{
  pairs: Array<Types.ProductionItemLinkPairInput> | Types.ProductionItemLinkPairInput;
}>;


export type GetProductionItemLinksPreviewQuery = { __typename?: 'Query', previewProductionItemLinks: Array<{ __typename?: 'ProductionItemLinkPairResult', rowIndex: number, productionItemId?: string | null, productionItemNumber?: string | null, salesItemId?: string | null, salesItemCode?: string | null, salesItemName?: string | null, currentSalesItemId?: string | null, currentSalesItemName?: string | null, outcome: Types.ProductionItemLinkPairOutcome, reason?: string | null }> };

export type ProductionItemLinkPairResultFragment = { __typename?: 'ProductionItemLinkPairResult', rowIndex: number, productionItemId?: string | null, productionItemNumber?: string | null, salesItemId?: string | null, salesItemCode?: string | null, salesItemName?: string | null, currentSalesItemId?: string | null, currentSalesItemName?: string | null, outcome: Types.ProductionItemLinkPairOutcome, reason?: string | null };

export type GetProductionItemNumberMatchesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetProductionItemNumberMatchesQuery = { __typename?: 'Query', productionItemNumberMatches: { __typename?: 'ProductionItemNumberMatches', matchCount: number, sharedCodeCount: number, matches: Array<{ __typename?: 'ProductionItemNumberMatch', productionItemId: string, productionItemNumber: string, salesItemId: string, salesItemCode: string, salesItemName: string, matchKind: Types.ItemCodeMatchKind }>, sharedCodes: Array<{ __typename?: 'ProductionItemSharedCode', productionItemId: string, productionItemNumber: string, candidates: Array<{ __typename?: 'SalesItemCandidate', salesItemId: string, salesItemCode: string, salesItemName: string }> }> } };

export const ProductionItemSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionItemSummary on ProductionItemDocument {
  id
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  resolvedLaborCostPerUnit
  resolvedLaborCostSourceType
  resolvedLaborCostSourceId
  resolvedLaborCostSourceName
  status
  catalogGenus
  catalogSeries
  catalogColor
  categoryCode
  salesItemId
  salesItemLinkedAutomatically
  createdAt
  createdBy
  updatedAt
  updatedBy
  combinedIntoProductionItemId
  combinedAt
  productionTaskEventAttachments {
    defaultAssignedTo
    eventId
  }
}
    `, {"fragmentName":"ProductionItemSummary"});
export const ProductionItemDataFragmentDoc = new TypedDocumentString(`
    fragment ProductionItemData on ProductionItemStateData {
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  status
  salesItemId
}
    `, {"fragmentName":"ProductionItemData"});
export const ProductionCombineFieldDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionCombineFieldDetails on ProductionCombineField {
  key
  label
  kind
  survivorValue
  loserValue
  resultValue
  isConflict
  keepBothAllowed
}
    `, {"fragmentName":"ProductionCombineFieldDetails"});
export const ProductionItemLinkPairResultFragmentDoc = new TypedDocumentString(`
    fragment ProductionItemLinkPairResult on ProductionItemLinkPairResult {
  rowIndex
  productionItemId
  productionItemNumber
  salesItemId
  salesItemCode
  salesItemName
  currentSalesItemId
  currentSalesItemName
  outcome
  reason
}
    `, {"fragmentName":"ProductionItemLinkPairResult"});
export const GetProductionItemsDocument = new TypedDocumentString(`
    query GetProductionItems($where: ProductionItemDocumentFilterInput, $order: [ProductionItemDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String, $includeCombined: Boolean! = false) {
  productionItems(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
    includeCombined: $includeCombined
  ) {
    nodes {
      ...ProductionItemSummary
      absorbedNumbers
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionItemSummary on ProductionItemDocument {
  id
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  resolvedLaborCostPerUnit
  resolvedLaborCostSourceType
  resolvedLaborCostSourceId
  resolvedLaborCostSourceName
  status
  catalogGenus
  catalogSeries
  catalogColor
  categoryCode
  salesItemId
  salesItemLinkedAutomatically
  createdAt
  createdBy
  updatedAt
  updatedBy
  combinedIntoProductionItemId
  combinedAt
  productionTaskEventAttachments {
    defaultAssignedTo
    eventId
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionItemCombinePreviewDocument = new TypedDocumentString(`
    query GetProductionItemCombinePreview($survivorId: String!, $loserId: String!) {
  productionItemCombinePreview(survivorId: $survivorId, loserId: $loserId) {
    preview {
      survivorId
      loserId
      fields {
        ...ProductionCombineFieldDetails
      }
      conflictCount
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCombineFieldDetails on ProductionCombineField {
  key
  label
  kind
  survivorValue
  loserValue
  resultValue
  isConflict
  keepBothAllowed
}`);
export const GetProductionItemLinksPreviewDocument = new TypedDocumentString(`
    query GetProductionItemLinksPreview($pairs: [ProductionItemLinkPairInput!]!) {
  previewProductionItemLinks(pairs: $pairs) {
    ...ProductionItemLinkPairResult
  }
}
    fragment ProductionItemLinkPairResult on ProductionItemLinkPairResult {
  rowIndex
  productionItemId
  productionItemNumber
  salesItemId
  salesItemCode
  salesItemName
  currentSalesItemId
  currentSalesItemName
  outcome
  reason
}`);
export const GetProductionItemNumberMatchesDocument = new TypedDocumentString(`
    query GetProductionItemNumberMatches {
  productionItemNumberMatches {
    matchCount
    sharedCodeCount
    matches {
      productionItemId
      productionItemNumber
      salesItemId
      salesItemCode
      salesItemName
      matchKind
    }
    sharedCodes {
      productionItemId
      productionItemNumber
      candidates {
        salesItemId
        salesItemCode
        salesItemName
      }
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionItems: build.query<GetProductionItemsQuery, GetProductionItemsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionItemsDocument, variables })
    }),
    GetProductionItemCombinePreview: build.query<GetProductionItemCombinePreviewQuery, GetProductionItemCombinePreviewQueryVariables>({
      query: (variables) => ({ document: GetProductionItemCombinePreviewDocument, variables })
    }),
    GetProductionItemLinksPreview: build.query<GetProductionItemLinksPreviewQuery, GetProductionItemLinksPreviewQueryVariables>({
      query: (variables) => ({ document: GetProductionItemLinksPreviewDocument, variables })
    }),
    GetProductionItemNumberMatches: build.query<GetProductionItemNumberMatchesQuery, GetProductionItemNumberMatchesQueryVariables | void>({
      query: (variables) => ({ document: GetProductionItemNumberMatchesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionItemsQuery, useLazyGetProductionItemsQuery, useGetProductionItemCombinePreviewQuery, useLazyGetProductionItemCombinePreviewQuery, useGetProductionItemLinksPreviewQuery, useLazyGetProductionItemLinksPreviewQuery, useGetProductionItemNumberMatchesQuery, useLazyGetProductionItemNumberMatchesQuery } = injectedRtkApi;
